import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React from "react";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add login logic here
    navigate("/dashboard");
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Login</h2>

        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              placeholder="Enter Email Address"
              fullWidth
              margin="normal"
            />
          </div>

          <div className="control_group">
            <label htmlFor="password">Password</label>
            <TextField
              id="password"
              name="password"
              placeholder="Enter Password"
              fullWidth
              type={showPassword ? "text" : "password"}
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="control_group d_flex">
            <div className="remember_box">
              <FormControlLabel
                control={<Checkbox />}
                name="remember"
                label="Remember me"
              />
            </div>
            <button
              type="button"
              className="anchor_link"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </button>
          </div>

          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
              variant="contained"
            >
              Login
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
